<template>
  <div>
    <div class="aiDashboard-title">{{$t('smartMonitor.dashboard.title')}}</div>
    <Row>
      <Col span="24">
        <Row style="width: 100%;background-color: #fff;height: 53px;padding-top: 10px;">
          <Col span="24">
            <Row :gutter="10">
              <!-- 应用名称 -->
              <Col span="4" style="padding: 4px 0px 10px 4px;">
                <Select filterable v-model="applicationName" @on-change="applicationNameChange(applicationName)" :placeholder="$t('aiMonitor.applicationNamePlaceholder')">
                  <Option v-for="item in applicationNameList" :value="item.id" :key="item.id">{{ item.name}}</Option>
                </Select>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
    <Row :gutter="10" style="margin-bottom: 10px;margin-top: 10px;">
      <!-- 应用健康状态 -->
      <Col span="12">
        <Card :padding="8" style="min-height: 387px;">
          <Row>
            <Col class="title">{{$t('smartMonitor.dashboard.applicationHealthStatus')}}</Col>
          </Row>
          <Row :gutter="16">
            <Col span="12" style="text-align: center;margin-top: 56px;padding-bottom: 14px;">
              <i-circle :percent=score :size="210" stroke-color="#5cb85c" dashboard>
                <span class="demo-Circle-inner" style="font-size:24px;color:#5cb85c"><i>{{score.toFixed(2)}}</i></span>
              </i-circle>
            </Col>
            <Col span="12">
              <Row :gutter="16" style="margin-top: 10px;margin-bottom: 24px;font-size: 13px;font-weight: 600;">
              <Row>
                  <Col span="12">{{$t('smartMonitor.dashboard.instanceResourceName')}}</Col>
                  <Col span="12">{{$t('smartMonitor.dashboard.rating')}}</Col>
                </Row>
              </Row>
              <Row :gutter="16">
                <Row v-for="item in errorInstanceDTOS.slice(0,3)" v-bind:data="item" v-bind:key="item.id" style="margin-bottom: 5px;">
                  <Col span="12">{{item.name}}</Col>
                  <Col span="12">{{item.score.toFixed(2)}}</Col>
                </Row>
              </Row>
              <Row :gutter="16" style="margin-top: 50px;margin-bottom: 24px;font-size: 13px;font-weight: 600;">
              <Row>
                  <Col span="12">{{$t('smartMonitor.dashboard.databaseResourceName')}}</Col>
                  <Col span="12">{{$t('smartMonitor.dashboard.rating')}}</Col>
                </Row>
              </Row>
              <Row :gutter="16">
                <Row v-for="list in errorDatabaseDTOS.slice(0,3)" v-bind:data="list" v-bind:key="list.id" style="margin-bottom: 5px;">
                  <Col span="12">{{list.databaseId}}</Col>
                  <Col span="12">{{list.score.toFixed(2)}}</Col>
                </Row>
              </Row>
            </Col>
          </Row>
        </Card>
      </Col>
      <!-- 资源列表 -->
      <Col span="12">
        <Card :padding="8" style="min-height: 387px;">
          <Row>
            <Col class="title">{{$t('smartMonitor.dashboard.resourceList')}}</Col>
          </Row>
          <Row>
            <Tabs size="small">
              <TabPane :label="$t('aiMonitor.instance')">
                <Table :no-data-text="$t('common.noData')" class="table-css" :columns="instanceColumn" :data="instanceData" height="280">
                  <template slot-scope="{row,index}" slot="detail">
                    <Button type="info" size="small" @click="instanceDetail(row)">{{ $t('ticket.list.detail') }}
                    </Button>
                  </template>
                </Table>
              </TabPane>
              <TabPane :label="$t('aiMonitor.database')">
                <Table :no-data-text="$t('common.noData')" class="table-css" :columns="databaseColumn" :data="databaseData" height="280">
                  <template slot-scope="{row,index}" slot="detail">
                    <Button type="info" size="small" @click="databaseDetail(row)">{{ $t('ticket.list.detail') }}
                    </Button>
                  </template>
                </Table>
              </TabPane>
            </Tabs>
          </Row>
        </Card>
      </Col>
    </Row>

    <!-- 资源指标配置 -->
    <Row style="margin-bottom: 10px;">
      <Col span="24">
        <Card :padding="8">
          <Row>
            <Col class="title">{{$t('smartMonitor.dashboard.resourceIndexConfig')}}</Col>
          </Row>
          <Table :no-data-text="$t('common.noData')" class="table-css" :columns="resourceMetricConfig" :data="resourceMetricConfigData" height="380"></Table>
        </Card>
      </Col>
    </Row>

    <!-- 监控指标告警 -->
    <Row style="margin-bottom: 10px;">
      <Col span="24">
        <Card :padding="8">
          <Row>
            <Col class="title">{{$t('smartMonitor.dashboard.MonitorIndexAlert')}}</Col>
          </Row>
          <Table :no-data-text="$t('common.noData')" class="table-css" :columns="monitorMetricAlert" :data="monitorMetricAlertData" height="380"></Table>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
  export default {
    name: 'AIDashboard',
    data() {
      return {
        score:0,
        applicationName: '',
        applicationNameList: [],
        resourceMetricConfig: [
          {
            title: this.$t('smartMonitor.dashboard.resourceType'),
            key: 'resourceTypeName'
          },
          {
            title: this.$t('smartMonitor.dashboard.resourceName'),
            key: 'resourceName'
          },
          {
            title: this.$t('smartMonitor.dashboard.resourceID'),
            key: 'resourceId'
          },
          {
            title: this.$t('smartMonitor.dashboard.index'),
            key: 'monitorName'
          },
          {
            title: this.$t('smartMonitor.dashboard.weight'),
            key: 'weightValue'
          },
          {
            title: this.$t('smartMonitor.dashboard.fittingDegreeEstimation'),
            key: 'fitting'
          }],
        monitorMetricAlert: [
          {
            title: this.$t('smartMonitor.dashboard.resourceType'),
            key: 'resourceTypeName'
          },
          {
            title: this.$t('smartMonitor.dashboard.resourceName'),
            key: 'resourceName'
          },
          {
            title: this.$t('smartMonitor.dashboard.resourceID'),
            key: 'resourceId'
          },
          {
            title: this.$t('smartMonitor.dashboard.index'),
            key: 'monitorName'
          },
          {
            title: this.$t('smartMonitor.dashboard.caseID'),
            key: 'ticketEntityId'
          },
          {
            title: this.$t('smartMonitor.dashboard.currentFittingDegree'),
            key: 'fitting'
          },
          {
            title: this.$t('smartMonitor.dashboard.currentIndexRating'),
            key: 'score'
          }],
        instanceColumn: [
          {
            title: this.$t('smartMonitor.dashboard.accountName'),
            key: 'accountName'
          },
          {
            title: this.$t('smartMonitor.dashboard.accountID'),
            key: 'accountIdString'
          },
          {
            title: this.$t('smartMonitor.dashboard.instanceName'),
            key: 'name'
          },
          {
            title: this.$t('smartMonitor.dashboard.instanceID'),
            key: 'instanceId'
          },
          {
            title: this.$t('smartMonitor.dashboard.weight'),
            key: 'weightValue'
          },
          {
            title: this.$t('smartMonitor.dashboard.rating'),
            key: 'score'
          },
          {
            title: this.$t('smartMonitor.dashboard.detail'),
            slot: 'detail'
          }],
        databaseColumn: [
          {
            title: this.$t('smartMonitor.dashboard.accountName'),
            key: 'accountName'
          },
          {
            title: this.$t('smartMonitor.dashboard.accountID'),
            key: 'accountIdString'
          },
          {
            title: this.$t('smartMonitor.dashboard.databaseName'),
            key: 'name'
          },
          {
            title: this.$t('smartMonitor.dashboard.databaseID'),
            key: 'databaseId'
          },
          {
            title: this.$t('smartMonitor.dashboard.weight'),
            key: 'weightValue'
          },
          {
            title: this.$t('smartMonitor.dashboard.rating'),
            key: 'score'
          },
          {
            title: this.$t('smartMonitor.dashboard.operation'),
            slot: 'detail'
          }],
        instanceData: [],
        databaseData: [],
        resourceMetricConfigData: [],
        monitorMetricAlertData: [],
        errorInstanceDTOS:[],
        errorDatabaseDTOS:[]
      }
    },
    mounted() {
      this.queryAiApplications();
    },
    methods: {
      // 切换应用名称
      applicationNameChange: function () {
        this.queryAiApplicationDashboard();
      },
      //查询应用
      queryAiApplications: function () {
        this.$api.aiMonitor.queryAiApplications({})
        .then(res => {
          this.applicationNameList = res.data;
          if(this.applicationNameList.length>0){
            this.applicationName=this.applicationNameList[0].id;
            this.queryAiApplicationDashboard();
          }
        })
      },
      queryAiApplicationDashboard:function(){
        this.$api.aiMonitor.queryAiApplicationDashboard("id",this.applicationName)
        .then(res => {
            // 实例
            this.instanceData=res.data.instanceDTOS;
            for(var i=0;i<this.instanceData.length;i++){
              this.instanceData[i].score=this.instanceData[i].score.toFixed(2);
            }
            // 数据库
            this.databaseData=res.data.databaseDTOS;
            for(var i=0;i<this.databaseData.length;i++){
              this.databaseData[i].score=this.databaseData[i].score.toFixed(2);
            }
            // 资源指标配置
            this.resourceMetricConfigData=res.data.aiResourceWeightRelationshipDTOS;
            // 监控指标告警
            this.monitorMetricAlertData=res.data.aiApplicationAlertDTOS;
            for(var i=0;i<this.monitorMetricAlertData.length;i++){
              this.monitorMetricAlertData[i].score=this.monitorMetricAlertData[i].score.toFixed(2);
            }
            this.errorInstanceDTOS=res.data.errorInstanceDTOS;
            this.errorDatabaseDTOS=res.data.errorDatabaseDTOS;
            this.score=res.data.score;
        })
      },
      // 实例详情
      instanceDetail: function (row) {
        this.$router.push({path: '/aiMonitor/instanceDetail/', query: {instanceId: row.id}});
      },
      // 数据库详情
      databaseDetail: function (row) {
        this.$router.push({path: '/aiMonitor/databaseDetail/', query: {databaseId: row.id}});
      }
    }
  }
</script>

<style scoped>
  .aiDashboard-title {
    width: 100%;
    font-size: 13px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 15px 0px 0px 4px;
    font-weight: 600;
  }

  .title {
    font-size: 13px;
    font-weight: 600;
    padding: 10px;
    float: left;
    color: #000;
  }
  /* 滚动条 */
  .table-css >>> .ivu-table-overflowY::-webkit-scrollbar {
      width: 10px;
      height: 10px;
  }
  .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background: #ccc;
  }
  .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-track {
      background: #eeeeef;
  }
  .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-corner {
      background-color: #eeeeef;
  }
  .table-css >>> .ivu-table-overflowX{
      overflow-x: hidden !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/ai_monitor/ai_dashboard/AIDashboard.vue